import { isSet } from '@core/util/value';
import { BusinessUser } from '@models/businesses';
import { Selector } from '@ngxs/store';
import { AppState } from '@state/app/app.state';
import { BusinessState } from '@state/business';
import { BusinessUsersState } from '@state/business-users/business-users.state';
import { NavigationState } from '@state/navigation/navigation.state';
import { SITE_SECTION } from '@state/navigation/page.model';
import { UserProfileState } from '@state/user-profile';
import { envTypes } from 'src/environments/env.types';
import { environment } from 'src/environments/environment';
import { initializeSyncStatus } from '../profile/integrations/closer-sync/closer-sync-integration.util';
import { STATUSES } from '@models/statuses';

export interface IntercomData extends Intercom_.IntercomSettings {
	businessId: string;
	role: string;
	production: boolean;
	custom_launcher_selector: string;
	admin: boolean;
	company: {
		id: string;
		name: string;
		company_id: string;
	};
	isCollegeUser: boolean;
	inLeap: boolean;
	using_word_only: boolean;
	isTreefortEnabled: boolean;
	isSyncEnabled: boolean;
}

const sectionsToHideNavForLEAP: SITE_SECTION[] = [SITE_SECTION.MatterCreation];

export class AppMainSelector {
	@Selector([AppState.loadedFromLeap, NavigationState.getSiteSection])
	static ShowSideNav(loadedFromLeap: boolean, section: SITE_SECTION): boolean {
		if (loadedFromLeap && sectionsToHideNavForLEAP.includes(section)) {
			return false;
		}

		return true;
	}

	@Selector([
		BusinessUsersState.getLoggedInBusinessUser,
		BusinessState.businessName,
		UserProfileState.getProfileFullName,
		BusinessState.isCollege,
		AppState.loadedFromLeap,
		BusinessState.useHtmlDocuments,
		BusinessState.getTreefortConnected,
	])
	static GetIntercomData(
		businessUser: BusinessUser,
		businessName: string,
		name: string,
		isCollege: boolean,
		loadedFromLeap: boolean,
		useHtmlDocuments: boolean,
		isTreefortEnabled: boolean,
	): IntercomData {
		if (!(businessUser && isSet(businessName) && isSet(name))) {
			return null;
		}

		return {
			app_id: environment?.intercomId,
			name,
			user_id: businessUser?.id,
			email: businessUser?.email,
			businessId: businessUser?.userBusinessId,
			role: businessUser?.role,
			admin: businessUser?.admin,
			production: environment.env === envTypes.PRODUCTION,
			custom_launcher_selector: '.bot-trigger--feedback',
			company: {
				id: businessUser?.userBusinessId,
				name: businessName,
				company_id: businessUser?.userBusinessId,
			},
			isCollegeUser: isCollege,
			inLeap: loadedFromLeap,
			using_word_only: !useHtmlDocuments,
			isTreefortEnabled,
			isSyncEnabled: initializeSyncStatus(businessUser) === STATUSES.CONNECTED,
		};
	}
}
